import { Divider, Flex, VStack } from '@chakra-ui/react';
import { SingleObject } from '../../types/ObjectTypes';
import { ListItem } from './ListItem/ListItem';
import { ObjectsParams } from '../../types/ParamsTypes';
import { ExtendedDetailsRoute } from '../../types/RoutesTypes';
import React, { useCallback } from 'react';
import { getObjectParamsFromRouteParams } from '../../services/Object/ObjectService';
import { Box } from '@chakra-ui/layout';

export interface ObjectListProps {
  objects: Array<SingleObject>;
  objectsParams: ObjectsParams;
  bookmarks: Array<ExtendedDetailsRoute>;
  handleBookmarkChange: Function;
  context?: string;
}

export const ObjectsList = (props: ObjectListProps): JSX.Element => {
  const { objects, objectsParams, bookmarks, handleBookmarkChange, context } = props;

  const getObjectsParamsFromBookmark = useCallback(
    id => {
      const bookmark = bookmarks.find(bookmark => bookmark.id === id);
      return bookmark ? getObjectParamsFromRouteParams(bookmark) : objectsParams;
    },
    [objectsParams, bookmarks],
  );

  const BOOKMARKS_LIST = 'BOOKMARKS_LIST';

  return (
    <Flex
      minH={objects.length ? '100vh' : 0}
      flexDirection={'row'}
      alignItems={'flex-start'}
      gridGap={8}>
      <VStack flex={1} width={'100%'}>
        {objects.map((object, idx) => {
          return (
            <Box key={idx} w={'100%'} pb={4}>
              <ListItem
                objectsParams={
                  context === BOOKMARKS_LIST
                    ? getObjectsParamsFromBookmark(object.baseData.uniqueId)
                    : objectsParams
                }
                object={object}
                bookmarks={bookmarks}
                handleBookmarkChange={handleBookmarkChange}
              />
            </Box>
          );
        })}
      </VStack>
    </Flex>
  );
};
